import DescriptionIcon from '@material-ui/icons/Description';
import HomeIcon from '@material-ui/icons/Home';
import PeopleIcon from '@material-ui/icons/People';
import React from 'react';
import { ENTITLEMENTS } from '../../core/utils/constants';

export const BASE_OPTIONS = [
  {
    name: "Project Home",
    url: 'project/detail',
    icon: <HomeIcon />
  },
  {
    name: "Project Information",
    url: 'project/edit',
    icon: <DescriptionIcon />
  },
  {
    name: "Permissions",
    url: 'project/permissions',
    entitlement: ENTITLEMENTS.EDIT_PERMISSIONS,
    icon: <PeopleIcon />
  }
];
